import './ExplorerJournal.scss';
import HeroImage from '../../atoms/HeroImage/HeroImage';
import { publicURL } from '../../../utils/axiosInstance';
import { useEffect, useState } from 'react';
import { sanityClient } from '../../../sanity.io/config';
import ExplorersJournalRow from './ExplorersJournalRow/ExplorersJournalRow';
import { ExplorersJournalRowType } from './ExplorersJournal.types';
import ExplorersJournalHeaderRow from './ExplorersJournalHeaderRow/ExplorersJournalHeaderRow';
import { EXPLORERS_JOURNAL } from '../../../constants/ExplorersJournal.constants';
import { formatDataFromSanityToExplorersJournals } from '../../../utils/utils';

function ExplorersJournal() {
  const [data, setData] = useState<ExplorersJournalRowType[]>();
  const [city, setCity] = useState<string>('');
  const [locations, setLocations] = useState<any[]>([]);
  const [types, setTypes] = useState([
    EXPLORERS_JOURNAL.SANITY_TYPES.CITY_GUIDE,
    EXPLORERS_JOURNAL.SANITY_TYPES.NEIGHBORHOOD_GUIDE,
    EXPLORERS_JOURNAL.SANITY_TYPES.LIVE_LIKE_A_LOCAL,
    EXPLORERS_JOURNAL.SANITY_TYPES.EVENTS
  ]);

  const options = [
    { value: EXPLORERS_JOURNAL.SANITY_TYPES.LIVE_LIKE_A_LOCAL, label: 'Live Like a Local' },
    { value: EXPLORERS_JOURNAL.SANITY_TYPES.CITY_GUIDE, label: 'City Guide' },
    { value: EXPLORERS_JOURNAL.SANITY_TYPES.NEIGHBORHOOD_GUIDE, label: 'Neighborhood Guides' },
    { value: EXPLORERS_JOURNAL.SANITY_TYPES.EVENTS, label: 'Events' }
  ];

  useEffect(() => {
    if (!locations.length) {
      sanityClient.fetch(`*[_type == "city"] | order(name asc)`).then(response => {
        if (response && response.length) {
          setLocations(response);
          //setCity(response[0]._id);
        }
      });
    }
  }, []);

  useEffect(() => {
    getDataFromSanity(buildSanityQuery());
  }, [types, city]);

  const buildSanityQuery = () => {
    let GROQ_query = '';
    if (city && city !== 'all-cities') {
      GROQ_query += `city._ref == "${city}"`;
    }
    if (types.length) {
      if (city && city !== 'all-cities') {
        GROQ_query += ' && ';
      }
      GROQ_query += '( ';
      for (let i = 0; i < types.length; i++) {
        if (i > 0) GROQ_query += ' || ';
        GROQ_query += `_type == "${types[i]}"`;
      }
      GROQ_query += ' )';
    }
    return GROQ_query;
  };

  const getDataFromSanity = (GROQ_query: string) => {
    sanityClient.fetch(`*[${GROQ_query}] | order(_createdAt asc) { ..., city-> }`).then(response => {
      if (response && response.length) {
        setData(formatDataFromSanityToExplorersJournals(response));
      }
    });
  };

  const handleTypeChange = (e: any) => {
    if (e === 'all') {
      setTypes(options.map(opt => opt.value));
    }
    if (e?.target?.value) {
      if (e.target.checked) {
        setTypes([...types, e.target.value]);
      } else {
        if (types.length > 1) setTypes(types.filter(each => each !== e.target.value));
      }
    }
  };

  const handleCityChange = (city: string) => {
    setCity(city);
  };

  return (
    <div className="explorer-journal">
      <HeroImage heroImageUrl={`${publicURL}/images/explorers-journal/happy-tourist-woman-smartphone-spain.jpeg`} position="top center" />
      <ExplorersJournalHeaderRow
        options={options}
        locations={locations}
        defaultValue={'All Cities'}
        onCityChange={handleCityChange}
        onTypeChange={handleTypeChange}
        types={types}
      />
      {data &&
        !!data.length &&
        data.map(each => {
          return (
            <ExplorersJournalRow
              title={each.title}
              city={each.city}
              journalSummary={each.summary}
              sanityImageUrl={each?.sanityImage}
              type={each.type}
              url={each.url}
              slug={each.slug}
              key={each.title}
            />
          );
        })}
    </div>
  );
}

export default ExplorersJournal;
